"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmptyMySalesActiveTab = void 0;
var _react = _interopRequireDefault(require("react"));
var _dsSpots = require("@olxbr/ds-spots");
var _ScreenPlaceholder = require("../../molecules/ScreenPlaceholder");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var EmptyMySalesActiveTab = exports.EmptyMySalesActiveTab = function EmptyMySalesActiveTab() {
  var REACT_APP_MYADS_URL = "https://conta.olx.com.br/anuncios/publicados";
  var handleCTAClick = function handleCTAClick() {
    window.open(REACT_APP_MYADS_URL, '_blank');
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenPlaceholder.ScreenPlaceholder, {
    spot: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsSpots.Megaphone, {
      shape: "square"
    }),
    title: "Poxa... voc\xEA ainda n\xE3o teve nenhum contato de comprador",
    text: "Veja as op\xE7\xF5es para vender ainda mais r\xE1pido.",
    cta: 'Quero vender mais rápido!',
    action: handleCTAClick
  });
};